function SLR_Element(_element)
{
	// parent element
	var self = this;
	self.element = _element;
	self.item = {
		id: undefined,
		invoice_id: undefined,
		contract_id: undefined,
		list_order: undefined,
		config: undefined,
		options_list: undefined,
		fee: undefined,
		broadcast: undefined,
		upgrade: undefined,
		deleted: false,
		element_type: undefined,
		date1: undefined,
		date2: undefined,
		cycle: undefined,
		cycle_date1: undefined,
		cycle_date2: undefined
	};

	self.save = function()
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "element");
		request.append("action", "auto");
		request.append("type", self.element.el.form.get_invoice_type());
		request.append("data", JSON.stringify(self.item));

		// add request to queue
		$.slr.db.add(request, self.callback);
		return false;
	};

	self.delete = function()
	{
		self.item.deleted = 1;
		self.save();
	};

	self.callback = function(x)
	{
		self.item.id = x.element_id;
		if (x.action == "create" && self.element.interface.tabs.guarantees.length && self.element.getContractID()) {
			self.element.interface.tabs.guarantees.load('/facture/guarantees/' + x.element_id + '/' + self.element.getContractID(), function(){
				self.element.interface.tabs.guarantees.Guarantees(self.element);
			});
		}
		self.element.update();
	}

	self.init = function()
	{
		if (self.element.find("input[name=element_id]").val()){
			self.item.id = parseInt(self.element.find("input[name=element_id]").val(), 10);
		}
	}();
}

$.fn.Element = function(elementList)
{
	var _e = this;
	_e.el = elementList;
	_e.model = new SLR_Element(_e);
	_e.interface = {
		close_button : _e.find(".close-button"),
		trash_button : _e.find(".trash-button"),
		duplicate_button : _e.find(".duplicate-button"),
		header : _e.find('.slr-el-header'),
		tabs : {
			contract : _e.find(".slr-contract-tab"),
			fee : _e.find(".slr-fee-tab"),
			guarantees : _e.find(".slr-guarantees-tab"),
			details : _e.find(".slr-details-tab"),
		},
		cells : {
			header_title : _e.find(".cell-header-title"),
			header_dates : _e.find(".cell-header-date"),
			base_fee : _e.find(".fee-indicator .value"),
			upgrade_fee : _e.find(".upgrade-indicator .value"),
			broadcast_fee : _e.find(".broadcast-indicator .value")
		}
	};
	_e.status = {
		_opened : _e.hasClass("selected"),
		set opened (is_opened){
			this._opened = is_opened;
			if (_e.status._opened){
				_e.addClass('selected');
			} else {
				_e.removeClass('selected');
			}
		},
		get opened(){
			return this._opened;
		}
	};

	_e.close = function()
	{
		_e.find("input").blur();
		_e.status.opened = false;
		return false;
	}

	_e.open = function()
	{
		if (!_e.status.opened){
			_e.status.opened = true;
			return false;
		}
	};

	_e.trash = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer cet élément?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer l'élément",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_e.model.delete(); // from db
				_e.slideUp("fast", function(){ // from view
					_e.el.remove_element(_e); // from list
					_e.remove(); // from dom
				});
			}
		});
		return false;
	};

	_e.duplicate = function()
	{
		_e.el.duplicate_element(_e); // in list
		return false;
	};

	_e.update = function()
	{
		_e.find("input[name=element_id]").val(_e.model.item.id);
		if (_e.interface.tabs.details.length) {
			_e.interface.tabs.details.details_list.setElementID(_e.model.item.id);
		}
		if (_e.interface.tabs.contract.length) {
			_e.interface.tabs.contract.load_element_files();
		}
	};

	_e.updateDetailsSummary = function()
	{
		if (_e.details_summary != undefined && _e.interface.tabs.details.length) {
			var details_items = _e.interface.tabs.details.details_list.model.details;
			_e.details_summary.setDetails(details_items);
			_e.el.form.updateTotals();
		}
	};

	_e.updateInterface = function()
	{
		// update interface
		if ("getHeaderTitle" in _e.interface.tabs.details){
			_e.interface.cells.header_title.text(_e.interface.tabs.details.getHeaderTitle());
			_e.interface.cells.header_dates.text(_e.interface.tabs.details.getHeaderDates());
		}
		if (_e.interface.tabs.fee.length){
			_e.interface.cells.base_fee.text(_e.interface.tabs.fee.getFee().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			_e.interface.cells.upgrade_fee.text(_e.interface.tabs.fee.getUpgrade().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
			_e.interface.cells.broadcast_fee.text(_e.interface.tabs.fee.getBroadcast().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
		} else if (_e.interface.tabs.guarantees.length){
			_e.interface.cells.base_fee.text(_e.interface.tabs.guarantees.getFee().toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));
		}
	};

	_e.setInitialOptionsList = function()
	{
		_e.model.item.config = _e.getConventionName();
		if (_e.interface.tabs.fee.length){
			_e.model.item.options_list = _e.interface.tabs.fee.getOptionsList();
			_e.model.item.fee = _e.interface.tabs.fee.getFee();
			_e.model.item.broadcast = _e.interface.tabs.fee.getBroadcast();
			_e.model.item.upgrade = _e.interface.tabs.fee.getUpgrade();
		}
	};

	_e.updateOptionsList = function()
	{
		// update options list online
		_e.model.item.config = _e.getConventionName();
		if (_e.interface.tabs.fee.length){
			_e.model.item.options_list = _e.interface.tabs.fee.getOptionsList();
			_e.model.item.fee = _e.interface.tabs.fee.getFee();
			_e.model.item.broadcast = _e.interface.tabs.fee.getBroadcast();
			_e.model.item.upgrade = _e.interface.tabs.fee.getUpgrade();
			_e.save();
		}

		// base fee changed, update list items
		_e.interface.tabs.details.details_list.updatedBaseFee();
	};

	_e.getBaseFee = function()
	{
		if (_e.interface.tabs.fee){
			return _e.interface.tabs.fee.getFee();
		} else {
			return 0;
		}
	};

	_e.getUpgradeFee = function()
	{
		if (_e.interface.tabs.fee){
			return _e.interface.tabs.fee.getUpgrade();
		} else {
			return 0;
		}
	};

	_e.getBaseOrUpgradeFee = function()
	{
		if (_e.interface.tabs.fee && _e.interface.tabs.details){
			if (_e.interface.tabs.details.get_value('element_type') == "UPGRADE"){	// default
				return _e.getUpgradeFee();
			} else {
				return _e.getBaseFee();
			}
		} else {
			return 0;
		}
	}

	_e.getTotal = function()
	{
		var total = 0;
		if (_e.details_summary != undefined && _e.interface.tabs.details.length) {
			var details_items = _e.interface.tabs.details.details_list.model.details;
			details_items.forEach(function(detail_item){
				total += detail_item.model.getBase();
			});
		}
		return total;
	};

	_e.getTotalDue = function()
	{
		var total = 0;
		if (_e.details_summary != undefined){
			var details_items = _e.interface.tabs.details.details_list.model.details;
			details_items.forEach(function(detail_item){
				total += detail_item.model.getDue();
			});
		}
		return total;
	};

	_e.save = function()
	{
		_e.model.save();
	};

	_e.set = function(key, value)
	{
		// update model
		_e.model.item[key] = value;
		_e.save();

		// update interface
		_e.updateInterface();
	}

	_e.getElementID = function()
	{
		return _e.model.item.id;
	};

	_e.get_element_index = function()
	{
		return _e.el.model.getIndexOf(_e.getElementID());
	};

	/* Convention info */
	_e.getConventionName = function()
	{
		if (_e.find("select[name=config]").length) {
			return _e.find("select[name=config]").val();
		}
		return 'prod_2020';
	};
	_e.getConventionType = function()
	{
		return _e.getConventionName().split("_")[0];
	};
	_e.getConventionData = function()
	{
		return $.slr.conventions[_e.model.item.config].fees;
	};
	_e.getConventionItems = function()
	{
		return $.slr.conventions[_e.model.item.config].items.items;
	};
	_e.getConventionTypes = function()
	{
		return $.slr.conventions[_e.model.item.config].items.types;
	};

	_e.getContractID = function()
	{
		if (_e.interface.tabs.contract.length){
			return _e.interface.tabs.contract.get_id();
		}
		return undefined;
	};

	_e.reachTab = function(tab_index)
	{
		// go to tab
		_e.find(".card-collapse:eq(0)").collapse('hide');
		if (tab_index != 1){ _e.find(".card-collapse:eq(1)").collapse('hide'); }
		if (tab_index != 2){ _e.find(".card-collapse:eq(2)").collapse('hide'); }
		var tab = _e.find(".card-collapse:eq(" + tab_index + ")");
		if (tab.hasClass("show")){
			TabOrder.focusTab(tab);
		} else {
			tab.one('shown.bs.collapse', function(){
				TabOrder.focusTab(tab);
			});
		}
		tab.collapse('show');

		// scroll to tab
		$('body, html').animate({
			scrollTop: (_e.find(".card-collapse:eq(" + (tab_index-1) + ")").offset().top - ($(".cat__core__top-sidebar").outerHeight(true) + 6))
		}, 150);
	};

	/*
	*	Contract follow up between tabs
	*/

	_e.contractCreated = function()
	{
		/* Update guarantees tab */
		if (_e.interface.tabs.guarantees.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID();
				if (x != _e && element_id && x.interface.tabs.contract.length){
					x.interface.tabs.contract.load('/facture/contract/' + element_id, function(){
						x.interface.tabs.contract.Contract(x);
					});
				}
			});
		}
	};

	_e.contractUpdated = function()
	{
		/* Update guarantees tab */
		/* An unsaved element has no convention yet: its creation callback reloads the tab */
		if (_e.interface.tabs.guarantees.length && _e.getElementID())
		{
			/* Reload for current element */
			var element_id = _e.getElementID(),
			contract_id = _e.getContractID();
			if (contract_id == undefined){
				contract_id = "";
			}
			_e.interface.tabs.guarantees.load('/facture/guarantees/' + element_id + "/" + contract_id, function(){
				_e.interface.tabs.guarantees.Guarantees(_e);
			});
		}
	};

	_e.contractChanged = function()
	{
		/* Update guarantees tab */
		if (_e.interface.tabs.guarantees.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID(),
				contract_id = x.getContractID();
				if (x != _e && contract_id && contract_id == _e.getContractID() && x.interface.tabs.guarantees.length){
					x.interface.tabs.guarantees.load('/facture/guarantees/' + element_id + '/' + contract_id, function(){
						x.interface.tabs.guarantees.Guarantees(x);
					});
				}
			});
		}
	};

	_e.contractRenamed = function()
	{
		/* Update contract tab */
		if (_e.interface.tabs.contract.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID();
				if (x != _e && element_id && x.interface.tabs.contract.length){
					x.interface.tabs.contract.load('/facture/contract/' + element_id, function(){
						x.interface.tabs.contract.Contract(x);
					});
				}
			});
		}
	};

	_e.contractDeleted = function()
	{
		/* Update contract tab */
		if (_e.interface.tabs.contract.length)
		{
			/* Reload for other elements */
			_e.el.model.each(function(x){
				var element_id = x.getElementID();
				if (x != _e && element_id && x.interface.tabs.contract.length){
					x.interface.tabs.contract.load('/facture/contract/' + element_id, function(){
						x.interface.tabs.contract.Contract(x);
						x.contractUpdated();
					});
				}
			});
		}
	};

	return function()
	{
		// immediately get properties
		_e.model.item.config = _e.getConventionName();

		// set interface
		_e.interface.close_button.on("click", _e.close);
		_e.interface.header.on("click", function(){
			if (!_e.status.opened){
				_e.open();
			} else {
				_e.close();
			}
			return false;
		});
		_e.interface.trash_button.on("click", _e.trash);
		_e.interface.duplicate_button.on("click", _e.duplicate);
		_e.on("click", _e.open);

		// initialize accordion
		_e.find(".accordion>.card").each(function(){
			var id = "tab" + Math.random().toString(36).substring(7);
			$(this).find(".card-header").attr("data-target", "#"+id).attr("data-toggle", "collapse");
			$(this).find(".card-collapse").attr("id", id);
			$(this).find(".card-collapse.collapse").collapse('hide');
		});

		// no accordion behavior on config select
		_e.find(".card-header select").on("click", function(e){
			return false;
		});

		// date pickers
		_e.find('.element-date-picker').each(function(){
			var field = $(this);
			field.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'DD/MM/YYYY',
				locale: 'fr-ca'
			})
		});

		// tabs
		switch (_e.el.form.get_invoice_type()) {
			case 1:	// InvoiceType::PUB
				_e.interface.tabs.fee.FeeCalculator(_e);
				_e.interface.tabs.contract.Contract(_e);
				_e.interface.tabs.details.Details(_e);
				break;
			case 2:	// InvoiceType::TV
				_e.interface.tabs.guarantees.Guarantees(_e);
				_e.interface.tabs.contract.Contract(_e);
				_e.interface.tabs.details.Details(_e);
				break;
			case 3:	// InvoiceType::PROD
				_e.interface.tabs.details.Details(_e);
				break;
		}

		// initialize loaded item
		_e.model.item.invoice_id = _e.el.form.getInvoiceID();
		if (_e.el.form.get_invoice_type() != 3) {	// not prod
			_e.model.item.config = _e.getConventionName();
			_e.model.item.contract_id = _e.getContractID();
		} else {
			_e.model.item.config = 'prod_2020';
		}

		// pub invoices only
		if (_e.interface.tabs.fee.length){
			_e.model.item.options_list = _e.interface.tabs.fee.getOptionsList();
			_e.model.item.fee = _e.interface.tabs.fee.getFee();
			_e.model.item.broadcast = _e.interface.tabs.fee.getBroadcast();
			_e.model.item.upgrade = _e.interface.tabs.fee.getUpgrade();
			_e.model.item.cycle = _e.interface.tabs.fee.get_value('cycle');
			_e.model.item.cycle_date1 = _e.interface.tabs.fee.get_value('cycle_date1');
			_e.model.item.cycle_date2 = _e.interface.tabs.fee.get_value('cycle_date2');
			_e.model.item.date1 = _e.interface.tabs.details.get_value('date1');
			_e.model.item.date2 = _e.interface.tabs.details.get_value('date2');
			_e.model.item.element_type = _e.interface.tabs.details.get_value('element_type');
		}

		// details summary
		_e.details_summary = _e.find(".slr-el-rows").DetailsSummary(_e);
		_e.updateDetailsSummary();

		// select with search
		_e.find(".element-select-search[name=element_type]").each(function(){
			$(this).select2({
				language: "fr"
			});
		});
		return _e;
	}();
};
